var map = {
	"./epidemic-1.png": "HoGM",
	"./epidemic-2.png": "iE0x",
	"./epidemic-3.png": "T2kE",
	"./epidemic-4.png": "Ey4W",
	"./epidemic-5.png": "Nmyl",
	"./epidemic-6.png": "dAqu",
	"./epidemic-7.png": "Twyw",
	"./epidemic-8.png": "8MGF",
	"./epidemic-9.png": "ooSc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+zIp";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list ^\.\/epidemic\-.*\.png$
// module id = +zIp
// module chunks = 1